import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class TaskResultMessage  {
    _originalTypeClassName = "zERP.BO.TaskResultMessage";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
TaskResultMessage.translate = translateService;
}
this.Message = null;
this.Severity = null;
this.TaskResultMessageKey = null;
this._key = this.TaskResultMessageKey = 0; 
}

static translate: TranslateService;
_key: any;
Message:any;
Severity:any;
private _TaskResultMessageKey:any;
get TaskResultMessageKey(): any {
    return this._TaskResultMessageKey;
  }
set TaskResultMessageKey(value: any) {
    this._TaskResultMessageKey = value;
    this._key = value;
  }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.TaskResultMessageKey == null || $this.TaskResultMessageKey == 0;
            }


}